var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesign2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 91,
    viewBox: "0 0 91 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3401_4503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3232 19.9234C13.3232 12.7785 19.1154 6.98633 26.2604 6.98633H64.3861C71.5311 6.98633 77.3232 12.7785 77.3232 19.9234V58.0492C77.3232 65.1942 71.5311 70.9863 64.3861 70.9863H26.2604C19.1154 70.9863 13.3232 65.1942 13.3232 58.0492V19.9234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2604 7.39061H64.3861C71.3078 7.39061 76.919 13.0018 76.919 19.9234V58.0492C76.919 64.9709 71.3078 70.582 64.3861 70.582H26.2604C19.3387 70.582 13.7275 64.9709 13.7275 58.0492V19.9234C13.7275 13.0018 19.3387 7.39061 26.2604 7.39061Z",
    stroke: "#B1C1CF",
    strokeWidth: 0.808569
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3401_4503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.1806 36.4863H44.6806C43.7601 36.4863 43.0139 37.2325 43.0139 38.153V45.653C43.0139 46.5735 43.7601 47.3197 44.6806 47.3197H52.1806C53.1011 47.3197 53.8472 46.5735 53.8472 45.653V38.153C53.8472 37.2325 53.1011 36.4863 52.1806 36.4863Z",
    stroke: "#243251",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6805 41.4857H38.8472C38.4052 41.4857 37.9813 41.3101 37.6687 40.9975C37.3561 40.685 37.1805 40.261 37.1805 39.819V32.319C37.1805 31.877 37.3561 31.4531 37.6687 31.1405C37.9813 30.8279 38.4052 30.6523 38.8472 30.6523H46.3472C46.7892 30.6523 47.2132 30.8279 47.5257 31.1405C47.8383 31.4531 48.0139 31.877 48.0139 32.319V33.1523",
    stroke: "#243251",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3401_4503",
    x: 0.386131,
    y: 0.517773,
    width: 89.8742,
    height: 89.8742,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.46856
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.46856
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.615686 0 0 0 0 0.686275 0 0 0 0 0.776471 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3401_4503"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3401_4503",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3401_4503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(35.5139 28.9863)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign2);
export default __webpack_public_path__ + "static/media/Design2.9229dcfe9d1a34fdabb51bd8d6c58916.svg";
export { ForwardRef as ReactComponent };